<template>
  <div>
    <input maxlength="2" name="desired-month" v-model="month" type="text" @focus="emitClear">
    <span>月</span>
    <input maxlength="2" name="desired-day" v-model="day" type="text" @focus="emitClear" class="day-input">
    <span>日</span>
    <div class="c-desired-select-wrapper">
      <select v-model="timeOfDay" name="" id="" @focus="emitClear" @blur="emitBlur">
        <option value="" disabled selected>希望時間帯</option>
        <option value="午前">午前</option>
        <option value="午後">午後</option>
      </select>
    </div>
  </div>
</template>

<script>
import ValidationWrapper from '@/components/common/validation/ValidationWrapper';
import ZipFieldInput from '@/components/common/validation/zip/ZipFieldInput';

export default {
  name: 'ValidatedDesiredField',
  props: ['value', 'rules', 'vid', 'expandedTooltip'],
  components: { ZipFieldInput, ValidationWrapper },
  data() {
    return {
      month: '',
      day: '',
      timeOfDay: '',
    };
  },
  methods: {
    emitClear() {
      this.$emit('clear');
    },
    emitBlur() {
      this.$emit('blur');
    },
    emitValue() {
      this.$emit('input', this.fullDate);
    },
  },
  computed: {
    fullDate: {
      get() {
        const combinedValue = `${this.month}月${this.day}日 ${this.timeOfDay}`;
        return this.month && this.day && this.timeOfDay ? combinedValue : '';
      },
      // set(newValue) {
      //   if (!newValue) {
      //     return "";
      //   }
      //   const split = newValue.split("-");
      //   this.firstSetValue = split[0];
      //   this.secondSetValue = split[1];
      // }
    },
  },
  watch: {
    month(e) {
      this.emitValue(e);
    },
    day(e) {
      this.emitValue(e);
    },
    timeOfDay(e) {
      this.emitValue(e);
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 50px;
}
select {
  height: 34px;
  width: 130px;
  appearance: none;
  padding-left: 8px;
}
.c-desired-select-wrapper {
  position: relative;
  display: inline-block;
  &::before {
    content: '';
    display: block;
    position: absolute;
    right: 10px;
    top: 30%;
    transform: rotate(90deg);
    height: 14px;
    width: 14px;
    background-image: url(/static/img/icon-arrow-originl.png);
    background-size: cover;
  }
}

.day-input, select {
  margin-left: 10px;
}
</style>
